var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 9.56667H11.3611C11.2205 9.12591 10.8741 8.77957 10.4334 8.63888V5.33333C10.4334 5.09371 10.2392 4.9 10 4.9C9.76086 4.9 9.56669 5.09371 9.56669 5.33333V8.63885C8.98908 8.82292 8.56669 9.36027 8.56669 10C8.56669 10.7906 9.20946 11.4333 10 11.4333C10.6394 11.4333 11.1771 11.011 11.3612 10.4333H13.6667C13.9059 10.4333 14.1 10.2396 14.1 10C14.1 9.76044 13.9062 9.56667 13.6667 9.56667ZM16.0665 3.2243C14.1814 1.52945 12.3267 0.9 10.0003 0.9C7.67393 0.9 5.82031 1.53072 3.93419 3.22426C3.73855 3.39993 3.63162 3.50346 3.44954 3.69307C1.61111 5.6075 0.9 7.5551 0.9 10C0.9 13.3338 2.35404 16.0469 5.38945 17.8411C5.62548 17.9806 5.76205 18.0545 6.00826 18.1754C7.44345 18.8801 8.57054 19.1 10 19.1C11.4295 19.1 12.5565 18.8801 13.9917 18.1754C14.238 18.0545 14.3745 17.9806 14.6106 17.8411C17.646 16.0469 19.1 13.3338 19.1 10C19.1 7.55505 18.3877 5.60861 16.5505 3.69311C16.3687 3.50354 16.2619 3.39998 16.0665 3.2243ZM10 18.2333C5.46023 18.2333 1.76667 14.5398 1.76667 10C1.76667 5.46023 5.46023 1.76667 10 1.76667C14.5398 1.76667 18.2333 5.46023 18.2333 10C18.2333 14.5398 14.5401 18.2333 10 18.2333Z",
    stroke: "#505766",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2c0429d49f9c74a80b0216f70bc880a5.svg";
export { ForwardRef as ReactComponent };